import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { AuthenticationService } from '../_services';
import { HandleErrorService } from '../_services/handleError.service';
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthenticationService, private router: Router, private toasterService: ToastrService,
        private error: HandleErrorService ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authService.isAuthenticated() || this.authService.isInitAuthenticated()) {
           let cloneReq;
           if(this.authService.getUserAuthData() !== null) {
               cloneReq = request.clone({
                   setHeaders: {
                       Authorization: `Bearer ${this.authService.getUserAuthData().token}`
                   }
               });
           } else {
               cloneReq = request.clone({
                   setHeaders: {
                       Authorization: `Bearer ${this.authService.getUserinit()}`
                   }
               });
           }

            return next.handle(cloneReq).do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    //continuando no http cycle
                }
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        this.router.navigate(['login']);
                    }
                }
            });
        }
        return next.handle(request).do(
                //sucesso
                (res: HttpResponse<any>) => {
                    if (res instanceof HttpResponse){
                //continuando no http cycle
                    }
                },
                (err: HttpErrorResponse) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401) {
                            this.router.navigate(['login']);
                        }
                    }
                    this.error.handleError(err);
                }
            );

    }
}
